module.exports = "/assets/js/c0eb4817741732836dc9d8446c0d186b.svg";